
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/real-estate/residential-real-estate/multichannel-messages",
      function () {
        return require("private-next-pages/industry/real-estate/residential-real-estate/multichannel-messages.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry/real-estate/residential-real-estate/multichannel-messages"])
      });
    }
  